// removed by extract-text-webpack-plugin
module.exports = {"GoalActionModalContent":"GoalActionModalContent---IUUKk","GoalActionModalHeader":"GoalActionModalHeader---hG9xL"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/playbook/components/GoalActionModal/style.styl
// module id = 6+Vu
// module chunks = 89